import { Box, Divider, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import 'features/setting/treatment-plans/treatment-plans/treatment-plans.css'
import { useCallback, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

/** TRANSLATION*/
import HeaderLabel from 'component/CardCustom/HeaderLabel'
import { useTranslation } from 'react-i18next'

/** STYLE */
import { colors } from 'constants/theme'
import useStyles from 'features/setting/treatment-plans/treatment-plans/style'
import * as UseStyled from 'features/treatments/SummaryTreatment/UseStyle'

/** UTILS || SLICE */
import { numberFormat } from 'utils/app.utils'

/** CONSTANT */
import { Icons, icons } from 'constants/images'

/** COMPONENT */
import TreatmentPlanTypeApi from 'api/setting/treatment-plans/treatment-plan-type.api'
import TreatmentPlanApi, { TreatmentPlanInterface } from 'api/setting/treatment-plans/treatment-plan.api'
import OperativeTypeApi from 'api/setting/treatments/operative-type.api'
import { TreatmentStateInterface, assignOrderIndex, fillMissingOrderIndex, historyToothChart, isEditTootChart, setEditTootChart, setEditTootChartType, setSummeryTreatments, setToothChartSelected, setTreatmentByKey, toothChartSelected, treatment } from 'app/slice/treatment.slice'
import { selectMe } from 'app/slice/user.slice'
import InputTextField from 'component/Input/InputTextField'
import { notiSuccess } from 'component/notifications/notifications'
import Tx from 'features/treatments/MainMenu/OPD/Tx'
import $ from 'jquery'
import _ from 'lodash'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import { useDispatch, useSelector } from 'react-redux'
import { routeName } from 'routes/routes-name'

const initStateErrorMessage = {
  TREATMENT_PLAN_TYPE_STRING_BASE: '',
  TREATMENT_PLAN_TYPE_MAXIMUM_LENGTH: '',
  TREATMENT_PLAN_TYPE_STRING_EMPTY: '',
  TREATMENT_PLAN_TYPE_ANY_REQUIRED: '',

  TREATMENT_PLAN_NAME_STRING_BASE: '',
  IS_DUPLICATE_TREATMENT_PLAN_NAME: '',
  TREATMENT_PLAN_NAME_MAXIMUM_LENGTH: '',
  TREATMENT_PLAN_NAME_STRING_EMPTY: '',
  TREATMENT_PLAN_NAME_ANY_REQUIRED: '',
  NAME: '',
  TYPE: '',
}

interface ItemsTreatmentPlans {
  typeId: number
  typeName: string
  value: ValueInterface[]
}
interface ValueInterface {
  itemId: string
  type: string
  itemName: string
  unit: string
  price: number
  img?: string
}

interface SummaryTablePlansInterface {
  typeId: number
  itemId: number
  itemCode: string
  itemName: string
  priceUnit: number
  color?: string
  teeth?: any
  teethJson?: string
  teethType?: string
  operativeId?: number

}

export default function FormTreatmentPlans() {
  const { t } = useTranslation()
  const classes = useStyles()
  const history = useHistory()
  const location: any = useLocation()
  const [initLocation, setInitLocation] = useState()
  const [editMenu, setEditMenu] = useState<TreatmentPlanInterface>()

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [plansName, setPlansName] = useState('')
  const [planTypes, setPlanTypes] = useState([])

  const [treatmentPlanId, setTreatmentPlanId] = useState<number>()
  const [selectPlanType, setSelectPlanType] = useState('')
  const [selectFilterItem, setSelectFilterItem] = useState('ALL')
  const [summaryTablePlans, setSummaryTablePlans] = useState<SummaryTablePlansInterface[]>([])

  const [operativeTypes, setOperativeTypes] = useState([])

  const isEditTootCharts: any = useSelector(isEditTootChart)
  const dispatch = useDispatch()

  const [search, setSearch] = useState('')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const user = useSelector(selectMe)
  const historyToothCharts = useSelector(historyToothChart)
  const valueToothChartSelected = useSelector(toothChartSelected)

  const treatments: TreatmentStateInterface = useSelector(treatment)

  const headTable = [
    {
      title: t('TREATMENT_PLAN.FORM.SUMMARY.TABLE.NO'),
      align: 'center'
    },
    {
      title: t('TREATMENT_PLAN.FORM.SUMMARY.TABLE.TOOTGH'),
      align: 'left'
    },
    {
      title: t('TREATMENT_PLAN.FORM.SUMMARY.TABLE.CODE'),
      align: 'left'
    },
    {
      title: t('TREATMENT_PLAN.FORM.SUMMARY.TABLE.ITEM'),
      align: 'left'
    },
    {
      title: t('TREATMENT_PLAN.FORM.SUMMARY.TABLE.PRICE'),
      align: 'right'
    }, {

      title: t('TREATMENT_PLAN.FORM.SUMMARY.TABLE.ACTION'),
      align: 'center'
    }
  ]

  //TABLE DISPLAY
  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(5)

  const loadTreatmentPlans = useCallback(() => {
    if (!initLocation) setInitLocation(location)

    if (initLocation !== undefined) {
      const { state }: any = initLocation
      setEditMenu(state)
      if (editMenu?.treatmentPlanId) onEdit()
    }
  }, [location, initLocation, editMenu])

  const loadOperative = useCallback(() => {
    if (!planTypes.length) TreatmentPlanTypeApi.findAll({ status: 'ACTIVE', pageLimit: 100 }).then(({ data }) => data && setPlanTypes(data))
    if (!operativeTypes.length) OperativeTypeApi.findAllActive({}).then(({ data }) => data && setOperativeTypes(data))
  }, [page, pageLimit, selectFilterItem, search])

  useEffect(() => {
    loadOperative()
    dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [] }))
    dispatch(setEditTootChartType(''))
    dispatch(setEditTootChart(null))
    dispatch(setToothChartSelected([]))
  }, [loadOperative]);

  useEffect(() => {
    loadTreatmentPlans()
  }, [loadTreatmentPlans])

  const loadTreatmentPlanById = async () => {
    if (editMenu?.treatmentPlanId) {
      const resp: any = await TreatmentPlanApi.findById(editMenu?.treatmentPlanId)
      if (resp.status === 200) {
        dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: fillMissingOrderIndex([...resp.data?.treatmentPlanItems, ...treatments.summeryTreatments]) }))
        // setTreatmentPlan(resp.data?.treatmentPlanItems)
      }
    }
  }

  useEffect(() => {
    loadTreatmentPlanById()
  }, [editMenu?.treatmentPlanId])

  const onEdit = () => {
    if (editMenu?.treatmentPlanId) {
      if (editMenu?.treatmentPlanId)
        setTreatmentPlanId(editMenu?.treatmentPlanId)
      setPlansName(editMenu.treatmentPlanName)
      setSelectPlanType(String(editMenu.treatmentPlanTypeId))
      const teethJson: any = []
      const tempSummaryTablePlans: any = editMenu.treatmentPlanItems?.map((tx: any) => {
        if (tx.teethJson !== "") {
          teethJson.push(JSON.parse(tx.teethJson))
        }
        const hasOverdue = _.some(treatments?.summeryTreatments, { isEdit: '0', doctorId: _.get(treatments.summeryTreatments[0], 'pinDoctorId') || null })
        const item = {
          ...tx,
          qty: 1,
          total: tx.price,
          doctorId: !hasOverdue ? _.get(treatments.summeryTreatments[0], 'pinDoctorId') || null : null,
          discount: 0,
          additional: 0,
          discountUnit: 'BAHT',
          additionalUnit: 'BAHT',
          dfAmount: null,
          cfAmount: null,
          dfDiscountAmount: 0,
          cfDiscountAmount: 0,
          dfDiscountUnit: 'BAHT',
          cfDiscountUnit: 'BAHT',
          isEdit: null
        }
        return item
      })
      const stampedPlans = assignOrderIndex(treatments.summeryTreatments, tempSummaryTablePlans)
      dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: [...treatments.summeryTreatments, ...stampedPlans] }))
      dispatch(setToothChartSelected([...teethJson, ...(valueToothChartSelected || []),]))
    }
  }

  const submit = () => {
    setDisabledSubmit(true)
    const tempTreatmentPlan: TreatmentPlanInterface = {
      treatmentPlanTypeId: parseInt(selectPlanType),
      treatmentPlanName: plansName,
      treatmentPlanItems: treatments.summeryTreatments.map((stp: SummaryTablePlansInterface) => {
        return {
          type: 'OPERATIVE',
          itemId: stp.operativeId || stp.itemId,
          teeth: stp.teeth || "",
          teethJson: stp.teethJson || "",
          teethType: stp.teethType || ""
        }
      })
    }
    if (!selectPlanType || !plansName) {
      setDisabledSubmit(false)
      const msg: any = {
        NAME: !plansName ? t(`TREATMENT_PLAN.MESSAGE.TREATMENT_PLAN_NAME`) : '',
        TYPE: !selectPlanType ? t(`TREATMENT_PLAN.MESSAGE.TREATMENT_PLAN_TYPE`) : '',
      }
      setErrorMessage({ ...initStateErrorMessage, ...msg })
      return false
    } else {
      if (!treatmentPlanId) create(tempTreatmentPlan)
      else {
        tempTreatmentPlan.status = editMenu?.status || 'ACTIVE'
        update(tempTreatmentPlan)
      }
    }
  }

  const create = (treatmentPlan: TreatmentPlanInterface) => {
    TreatmentPlanApi.create(treatmentPlan)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t(`TREATMENT_PLAN.MESSAGE.SUCCESS.CREATE`), '', null, () => {
            return
          })
          history.push(routeName.treatmentPlans)
        }
        else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN.MESSAGE.${err.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TREATMENT_PLAN.MESSAGE.${err.message}`) } })
      })
  }

  const update = (treatmentPlan: TreatmentPlanInterface) => {
    TreatmentPlanApi.update(Number(treatmentPlanId), treatmentPlan)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`TREATMENT_PLAN.MESSAGE.SUCCESS.UPDATE`), '', null, () => {
            return

          })
          history.push(routeName.treatmentPlans)
        }
        else {
          const err = res.response?.data
          setErrorMessage({ ...errorMessage, ...{ [err?.message]: t(`TREATMENT_PLAN.MESSAGE.${err?.message}`) } })
        }
        setDisabledSubmit(false)
      })
      .catch((e) => {
        const err = e.response?.data
        setDisabledSubmit(false)
        setErrorMessage({ ...errorMessage, ...{ [err?.message]: t(`TREATMENT_PLAN.MESSAGE.${err?.message}`) } })
      })
  }

  const onDelete = (index: any) => {
    const products: any = []
    _.forEach(summaryTablePlans, (data: any, i: any) => {
      if (i !== index) products.push(data)
    });
    setSummaryTablePlans([...products])
    const items = _.filter(treatments.summeryTreatments, (treatmentSummary, i: number) => i !== index)
    const toothChartSelected: any = []

    if (!_.isEmpty(items)) {
      _.map(items, (item, index) => {
        if (item.teethJson) toothChartSelected.push(JSON.parse(item.teethJson))
      })
    }
    dispatch(setTreatmentByKey({ key: 'summeryTreatments', value: items }))
    dispatch(setToothChartSelected([...historyToothCharts, ...toothChartSelected]))
    dispatch(setEditTootChart(null))
    dispatch(setEditTootChartType(''))
  }

  const clearErrorMessage = async () => setErrorMessage(initStateErrorMessage)

  const editToothChart = async (id: number) => {
    if (!treatments.summeryTreatments[id].teeth) {
      const resp: any = await OperativeTypeApi.findById(treatments.summeryTreatments[id].operativeTypeId || treatments.summeryTreatments[id].itemTypeId)
      if (resp.status === 200) {
        dispatch(setSummeryTreatments({ index: id, key: 'color', value: resp.data.color }))
        $('.div-component').delay(500).animate({ scrollTop: 0 }, 500)
        dispatch(setEditTootChartType(treatments.summeryTreatments[id].teethType))
        dispatch(setEditTootChart(id))
      }
    } else {
      $('.div-component').delay(500).animate({ scrollTop: 0 }, 500)
      dispatch(setEditTootChartType(treatments.summeryTreatments[id].teethType))
      dispatch(setEditTootChart(id))
    }
  }

  return (
    <Box>
      <HeaderLabel
        text={`${treatmentPlanId ? t('TREATMENT_PLAN.FORM.FORM_EDIT') : t('TREATMENT_PLAN.FORM.FORM_ADD')}`}
        navigator={{ previousTo: routeName.treatmentPlans, previousTitle: t('TREATMENT_PLAN.TITLE'), currentTitle: treatmentPlanId ? t('TREATMENT_PLAN.FORM.FORM_EDIT') : t('TREATMENT_PLAN.FORM.FORM_ADD') }}
        goBack={routeName.treatmentPlans}
        onSubmit={submit}
        disabled={disabledSubmit}
      />
      <Box padding="24px">
        <Box boxShadow={3} width="100%" paddingX="32px" paddingY="24px">
          <Grid container spacing={2}>
            <Grid item sm={6} lg={4}>
              <SelectInput
                onChange={(event) => {
                  const value = event.target.value
                  if (value) {
                    setSelectPlanType(value)
                    clearErrorMessage()
                  }
                }}
                required
                label={t('TREATMENT_PLAN.FORM.TREATMENT_PLAN_TYPE')}
                value={selectPlanType}
                helperText={errorMessage.TYPE || ''}
                options={planTypes.map((obj: any) => {
                  return ({ value: obj.treatmentPlanTypeId, name: obj.treatmentPlanTypeName })
                })}
              />
            </Grid>
            <Grid item sm={6} lg={4}>
              <TextInput
                label={t('TREATMENT_PLAN.FORM.TREATMENT_PLAN_NAME')}
                value={plansName}
                onChange={(e) => {
                  setPlansName(e.target.value)
                  clearErrorMessage()
                }}
                required
                onKeyPress={() => { clearErrorMessage() }}
                helperText={errorMessage.NAME || errorMessage.IS_DUPLICATE_TREATMENT_PLAN_NAME || ''}
                fullWidth
              />
            </Grid>
          </Grid>
          <Divider sx={{ marginY: '16px', backgroundColor: 'transparent', opacity: 1, borderColor: `${colors.lightGray} !important`, marginLeft: '-8px !important', marginRight: '-8px !important' }} />
          <Box>
            <Tx
              userId={user.userId}
              patientId={0}
              type={"SettingTreatmentPlan"}
              hasCreateTreatment={'PERMISS'}
            />
          </Box>

          <Typography fontWeight={600} color={colors.themeMainColor}>
            {t('TREATMENT_PLAN.FORM.SUMMARY_PLAN')}
          </Typography>

          <TableContainer component={Paper} style={{ boxShadow: 'none', paddingTop: '24px' }}>
            <Table aria-label="simple table" style={{ minWidth: '1024px' }}>
              <TableHead className={classes.header}>
                <TableRow>
                  {headTable.map((title: any) => (
                    <TableCell key={title} align={title.align}>
                      <div className={`${classes.titleSecond}`}>{title.title}</div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody className={`sm-data-table ${classes.body}`}>
                {treatments.summeryTreatments?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} className="align-middle text-center p-2" style={{ fontSize: '16px' }}>{t('REGISTER.NO_ITEM')}</TableCell>
                  </TableRow>
                )}
                {treatments.summeryTreatments
                  .map(({ itemId, operativeCode, itemCode, operativeName, itemName, price, teeth, isPriceRange, minSalePrice, maxSalePrice }: any, index: any) => {
                    return (
                      <TableRow key={`index-opd-${index}`}>
                        <TableCell align='center' width="5%" className='p-3' style={{ fontSize: '16px' }}>{index + 1}</TableCell>
                        <TableCell align='left' width="25%" className='p-3' style={{ fontSize: '16px' }}>
                          <>
                            <UseStyled.InputToothChart className={`d-sm-flex w-100 text-nowrap `}>
                              <InputTextField disabled value={teeth || ''} />
                              <UseStyled.BtnEditToothChart disableFocusRipple disableRipple
                                onClick={() => editToothChart(index)}
                                className={`p-0 ml-2 ${isEditTootCharts === index + 1 ? 'active' : ''} `}>
                                {isEditTootCharts === index ? <Icons.ToothSolid /> : <Icons.ToothOutlined />}
                              </UseStyled.BtnEditToothChart>
                            </UseStyled.InputToothChart>
                          </>
                        </TableCell>
                        <TableCell width="10%" className='p-3' style={{ fontSize: '16px' }}>{operativeCode || itemCode}</TableCell>
                        <TableCell width="25%" className='p-3' style={{ fontSize: '16px' }}>{operativeName || itemName}</TableCell>
                        <TableCell align='right' width="10%" className='p-3' style={{ fontSize: '16px' }}>{isPriceRange === '1' && maxSalePrice ? `${numberFormat(minSalePrice || 0)} - ${numberFormat(maxSalePrice)}` : numberFormat(price)}</TableCell>
                        <TableCell align='center' width="7%">
                          <IconButton disableFocusRipple disableRipple onClick={(e) => onDelete(index)} className="p-0" sx={{ backgroundColor: 'transparent' }}>
                            <img src={icons.btnTrash} alt="discard" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <Box height="54px" marginTop="8px" bgcolor="#F7F8F8" display="flex" justifyContent="end" alignItems="center" >
            <Box display="flex" flexDirection="row" alignItems="center" gap="128px" marginRight="28px">
              <Typography fontWeight={500} fontSize="18px">{t('TREATMENT_SUMMARY.TITLE.SUM_TOTAL')}</Typography>
              <Typography fontWeight={500} fontSize="18px">{numberFormat(treatments.summeryTreatments.map(({ price }: any) => price).reduce((a: any, b: any) => a + b, 0) || 0)} {t('CURRENCY_CHANGE.TH')}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
